import React from 'react';
import { RsvpProvider } from './context/RsvpContext';
import { BrowserRouter } from 'react-router-dom';

type AppProvidersProps = {
    children: React.ReactNode;
};

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
    return (
        <RsvpProvider>
            <BrowserRouter>
                {children}
            </BrowserRouter>
        </RsvpProvider>
    );
};